import { createMultiStyleConfigHelpers, } from "@chakra-ui/styled-system";
import { textStyles, colors } from "../../../../theme/foundations/generated";
import { DrawerVariant } from "../../Drawer/Drawer.types";
import { Display } from "../../Drawer/helper";
const OPACITY = 0.9;
const colorConverter = (colorInHexValue) => `${colorInHexValue}${Math.round(OPACITY * 255).toString(16)}`;
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    "drawerContainer",
    "drawer",
    "drawerContent",
    "drawerFooter",
    "titleContainer",
    "title",
    "icon",
    "closeButton",
    "closeButtonContainer",
    "slide",
    "backdrop",
]);
const baseStyle = definePartsStyle(({ display, title, icon }) => {
    var _a, _b;
    return ({
        drawerContainer: {
            position: "absolute",
            display: "flex",
            top: "0px",
            left: "0px",
            right: "0px",
            bottom: "0px",
            overflow: "hidden",
            zIndex: 999,
        },
        drawer: {
            position: "relative",
            padding: "0 2.5rem 1.5rem",
        },
        drawerContent: {
            paddingTop: ".5rem",
        },
        drawerFooter: {
            paddingTop: "2.5rem",
        },
        titleContainer: {
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        title: Object.assign(Object.assign({}, textStyles.title.desktopMain), { color: (_a = title === null || title === void 0 ? void 0 : title.color) !== null && _a !== void 0 ? _a : "semantic.text.primary", textAlign: "center" }),
        icon: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "0.5rem",
            color: (_b = icon === null || icon === void 0 ? void 0 : icon.color) !== null && _b !== void 0 ? _b : "semantic.text.primary",
        },
        closeButtonContainer: {
            position: "relative",
            display: "flex",
            padding: "1.5rem 0",
            justifyContent: "flex-end",
        },
        closeButton: {
            display: "flex",
        },
        slide: {
            position: "absolute",
            background: "#fff",
            height: "100%",
            zIndex: 1000,
            overflow: "auto",
            width: display === Display.DESKTOP ? "50%" : "100%",
            left: display === Display.DESKTOP ? "50%" : "0%",
            transition: "transform 1s",
        },
        backdrop: {
            position: "relative",
            height: "100%",
            width: "100%",
            background: colorConverter(colors.semantic.icon.primary),
        },
    });
});
const variants = {
    [DrawerVariant.SIDE_PANEL]: definePartsStyle(({ display }) => ({
        slide: {
            width: display === Display.DESKTOP ? "30%" : "100%",
            left: display === Display.DESKTOP ? "70%" : "0%",
        },
        title: Object.assign(Object.assign({}, textStyles.title.mobileCard), { color: "semantic.text.secondary", textAlign: "center" }),
        closeButton: {
            position: "absolute",
            right: "4",
        },
        drawer: {
            padding: 0,
        },
        titleContainer: {
            padding: "1rem 1.5rem",
            justifyContent: "center",
            gap: 4,
            alignSelf: "stretch",
            height: "16",
            alignItems: "center",
            borderBottom: "1px solid",
            borderColor: " semantic.border.secondary",
        },
    })),
    [DrawerVariant.DEFAULT]: definePartsStyle({}),
};
const sizes = {
    desktop: definePartsStyle({}),
    tablet: definePartsStyle({
        drawer: {
            padding: "0 1.5rem 1rem",
        },
    }),
    mobile: definePartsStyle({
        drawer: {
            padding: "0 1rem 1rem",
        },
        title: Object.assign({}, textStyles.subtitle.desktopMain),
    }),
};
const InnerDrawerTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    sizes,
    defaultProps: {
        size: "desktop",
        variant: DrawerVariant.DEFAULT,
    },
});
export default InnerDrawerTheme;
//# sourceMappingURL=InnerDrawer.default.js.map